module.exports = __webpack_public_path__ + "img/gigihpack-logo.8dc8a4fe.png";